import { render, staticRenderFns } from "./PhoneTo.vue?vue&type=template&id=4413afd5"
import script from "./PhoneTo.vue?vue&type=script&lang=ts"
export * from "./PhoneTo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4413afd5')) {
      api.createRecord('4413afd5', component.options)
    } else {
      api.reload('4413afd5', component.options)
    }
    module.hot.accept("./PhoneTo.vue?vue&type=template&id=4413afd5", function () {
      api.rerender('4413afd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PhoneTo.vue"
export default component.exports